import * as React from 'react';

import LoginForm from '@app/components/Pages/Resources/Login/LoginForm';
import withSeo from '@app/components/LocalCommon/HigherOrderComponents/WithSeo';

import '@app/scss/components/login.scss';

const Login = ({match}) => {

	return (
		<div className="login__wrapper">
			<div className="login">
				<div className="login-body">
					<h1>Veterinarian Portal Login</h1>
					<h5>Log in to see exclusive resources for veterinarians.</h5>
					<LoginForm match={match} />
					<div className="login-forgot">
						<h6>Forgot your password? Email</h6>
						<a href="mailto:Resources@LapofLove.com">Resources@LapofLove.com</a>
					</div>

				</div>
			</div>
		</div>

	);
};

export default withSeo(Login, state => state.loginPage, 'loginPage', 'veterinary-resources/login');